import { createNS } from "@ontologies/core";

const umbelRc = createNS("http://umbel.org/umbel/rc/");

export default {
  ns: umbelRc,
};
